import { useState } from 'react';
import { Button } from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { CaptureDialog } from './CaptureDialog';
import { useCaptureProposals } from './queries';

export const CaptureEntry = ({ caseId, hasClient }: { caseId: number; hasClient: boolean }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const proposals = useCaptureProposals(caseId, 1, hasClient);
  return (
    <>
      <Button size="small" startIcon={<AutoAwesome />} disabled={!hasClient} onClick={() => setOpen(true)}>
        {t('copilot.capture.open')}
        {proposals.data?.total ? ` (${proposals.data.total})` : ''}
      </Button>
      {open && hasClient && <CaptureDialog key={caseId} caseId={caseId} onClose={() => setOpen(false)} />}
    </>
  );
};
